import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate()

  const navigateAboutUs = () => {
    navigate("/AboutUs")
  }

  const navigateTermsConditions = () => {
    navigate("/terms-&-conditions")
  }

  const navigatePrivacyPolicy = () => {
    navigate("/privacy-policy-statement")
  }
  return (
    <footer>
      <div className="bg-white p-8 md:px-10 lg:px-24 lg:py-10">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row md:justify-between gap-8 text-sm">
          <div className="flex flex-col md:justify-start">
            <img
              src="/logos/Neevay_Logo.png"
              alt='Neevay'
              className='w-[100px] h-fit'
            />
            <div className='flex flex-col '>
              <button onClick={navigateAboutUs} className='hover:text-orange-500 text-start underline'>About Us</button>
              <button onClick={navigateAboutUs} className='hover:text-orange-500 text-start underline'>Careers</button>
              <button onClick={navigateAboutUs} className='hover:text-orange-500 text-start underline'>Blogs</button>
              <button onClick={navigateAboutUs} className='hover:text-orange-500 text-start underline'>Services</button>
            </div>
          </div>
          <div className="md:text-left">
            <div className="font-semibold text-lg md:text-xl mb-2">Company Info</div>
            <p>1st floor, IndiaLand, behind Grand Highstreet mall,</p>
            <p>Hinjawadi Phase 1, Pune, Maharashtra- 411057</p>
            <div className='flex space-x-4 pt-4'>
                <a href="https://www.instagram.com/neevay_official/" target="blank">
                  <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/homepage_4_instagram.svg" alt="instagram logo" className='w-[18px] h-[18px] filter invert' />
                </a>
                <a href="https://www.linkedin.com/company/neevay/mycompany/" target="blank">
                  <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/homepage_4_linkedin.svg" alt="linkedin logo" className='w-[18px] h-[18px] filter invert' />
                </a>
                <a href="https://www.youtube.com/channel/UC3dTz8WCJBJXHKWmewBlvfw/about" target="blank">
                  <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/homepage_4_youtube.svg" alt="YouTube logo" className='w-[25px] h-[18px] filter invert' />
                </a>
                <a href="https://twitter.com/neevayofficial?lang=en" target="blank">
                  <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/homepage_4_twitter.svg" alt="twitter logo" className='w-[20px] h-[18px] filter invert' />
                </a>
              </div>
          </div>
          <div className="md:text-left">
            <div className="font-semibold text-lg md:text-xl mb-2">Contact</div>
            <p>Phone: +91-9373759782</p>
            <p>Email: demo@neevay.com</p>
            {/* <p>Website: www.neevay.com</p> */}
          </div>
        </div>
      </div>
      <div className="bg-[#0b0b0b] text-gray-400 text-center p-4">
        <p className="text-sm">
          © 2025 Neevay. All rights reserved. |
          <button onClick={navigatePrivacyPolicy} className="hover:text-white focus:outline-none mx-2">
            Privacy Policy
          </button>
          |
          <button onClick={navigateTermsConditions} className="hover:text-white focus:outline-none mx-2">
            Terms of Use
          </button>
        </p>
      </div>
    </footer>
  );
}
